import { AllocationEntitiesTable } from "features/allocations/AllocationEntitiesTable";
import { AllocationEditTabProps } from "features/allocations/edit/AllocationEditTabProps";
import { useAllocationSetupForm } from "features/allocations/setup/AllocationSetupForm";
import { useAllocationRuleVersionListSuspense } from "gen/endpoints/allocation-rule/allocation-rule";
import { useAllocationRuleEdgeCreate } from "gen/endpoints/allocation-rule-edge/allocation-rule-edge";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import Form from "shared/components/form/Form";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxCollapse } from "shared/components/table/box/TableBoxCollapse";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";

export const AllocationEditTabInvestingEntities: React.FC = () => {
  const { fundFamilyId, allocationRuleId } =
    useOutletContext<AllocationEditTabProps>();

  const { t } = useTranslation(["common", "allocation"]);

  const { mutateAsync: createAllocationRuleEdge } =
    useAllocationRuleEdgeCreate();

  const { form, handleSubmit, tableProps } = useAllocationSetupForm(
    fundFamilyId,
    allocationRuleId,
  );

  const { data: tableData } = useAllocationRuleVersionListSuspense(
    fundFamilyId,
    allocationRuleId,
  );

  const onSubmit = handleSubmit(async (data) => {
    await createAllocationRuleEdge({
      fundFamilyId,
      data,
    });
  });

  return (
    <PageTabBody>
      <Form form={form} onSubmit={onSubmit} successMessage={t("common:saved")}>
        <TableBox>
          <TableBoxHeader>
            <TableBoxTitle>{t("allocation:ruleVersions")}</TableBoxTitle>
            <DataTableBoxActions />
          </TableBoxHeader>
          <TableBoxCollapse>
            <TableBoxBody>
              <DataTable data={tableData} showAllRows={true} />
            </TableBoxBody>
          </TableBoxCollapse>
        </TableBox>
        <AllocationEntitiesTable {...tableProps} isEditable={false} />
      </Form>
    </PageTabBody>
  );
};
